import React from 'react';
import { ProToggleProps } from '../types';

const ProToggle: React.FC<ProToggleProps> = ({ isPro, onToggle }) => {
  return (
    <div className="flex items-center justify-center gap-3 mb-6">
      <span className={`text-sm font-medium ${!isPro ? 'text-blue-600' : 'text-gray-400'}`}>
        Basic
      </span>
      <button
        onClick={onToggle}
        className={`
          relative w-14 h-7 rounded-full transition-colors duration-300
          ${isPro ? 'bg-gradient-to-r from-purple-500 to-pink-500' : 'bg-gray-300'}
        `}
        style={{ minWidth: '56px' }}
      >
        <span
          className="absolute w-5 h-5 bg-white rounded-full shadow-md transition-all duration-300"
          style={{
            top: '4px',
            left: isPro ? '32px' : '4px'
          }}
        />
      </button>
      <span className={`text-sm font-medium ${isPro ? 'text-purple-600' : 'text-gray-400'}`}>
        Pro
        {isPro && (
          <span className="ml-1 px-1.5 py-0.5 text-xs bg-purple-100 text-purple-700 rounded">
            Detailed
          </span>
        )}
      </span>
    </div>
  );
};

export default ProToggle;
